import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.gl',
    'package:data.higherEd.orgStructureSpaceWfuhs',
    'package:data.higherEd.research.awardsWfuhs',
    'package:data.higherEd.research.projectsWfuhs',
    'package:data.higherEd.research.sponsors',
    'package:data.higherEd.spaceUsageWfuhs',
  ],
  description: 'TODO',
  name: 'Research Data - Performance',
} as const satisfies core.quiver.Package
